export const useAxiosHelper = () => {
  // Attend une ref error d'asyncData
  const getAxiosErrorFromAsyncData = (errorRef) => {
    if (!errorRef || !errorRef.value) {
      return null;
    }
    // Actuellement l'erreur d'origine se trouve dans la clef cause...
    if (errorRef.value.cause) {
      return errorRef.value.cause;
    }
    // En cas d'évolution
    if (errorRef.value.response) {
      return errorRef.value;
    }
    return null;
  }

  const getErrorStatus = (axiosError, defaultStatus = 500) => {
    if (
      axiosError &&
      axiosError.response &&
      axiosError.response.data &&
      axiosError.response.data.status_code
    ) {
      return axiosError.response.data.status_code;
    } else if (
      axiosError &&
      axiosError.response
    ) {
      return axiosError.response.status
    } else if (axiosError && axiosError.status_code) {
      return axiosError.status_code;
    }
    return defaultStatus;
  }

  const getErrorMessage = (error) => {
    if (error && error.response && error.response.data && error.response.data.message) {
      return error.response.data.message;
    }
    return "Une erreur est survenue.";
  }

  const getHead = (axiosResponse) => {
    return axiosResponse.value && axiosResponse.value.meta && axiosResponse.value.meta.head
      ? axiosResponse.value.meta.head
      : {};
  }
  const isPageIndexError = (axiosError) => {
    if (
      axiosError.response &&
      axiosError.response.data &&
      axiosError.response.data.meta &&
      axiosError.response.data.meta.error &&
      axiosError.response.data.meta.error.invalid_value === "pageindex"
    ) {
      return true;
    }
    return false;
  };

  const throwIfAxiosError = (errorRef) => {
    const responseError = getAxiosErrorFromAsyncData(errorRef);
    if (responseError) {
      throw showError({ statusCode: getErrorStatus(responseError, 504), statusMessage: getErrorMessage(responseError) });
    }
  }

  return {
    getAxiosErrorFromAsyncData,
    getErrorStatus,
    getErrorMessage,
    getHead,
    isPageIndexError,
    throwIfAxiosError
  }
}